import * as yup from "yup";

export const PuntoGeograficoSchema = yup.object().shape({
  type: yup.string().required().default("Point"),
  coordinates: yup
    .array()
    .of(yup.number().typeError("errors.puntoGeografico.coordinates.type"))
    .required("errors.puntoGeografico.coordinates.required")
    .default([0, 0]),
});
